import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dollar",
  "use": "dollar-usage",
  "viewBox": "0 0 11 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 18\" id=\"dollar\"><path fill=\"none\" stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5.5 1v16M9.25 3.91H3.625C2.175 3.91 1 5.048 1 6.454 1 7.86 2.175 9 3.625 9h3.75C8.825 9 10 10.14 10 11.545c0 1.406-1.175 2.546-2.625 2.546H1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol